import Marquee from "react-fast-marquee";

export default function Ticker({ text }) {
  const words = (text || "Precision Sourcing").split("—").map((w) => w.trim()).filter(Boolean);
  return (
    <section className="relative py-5 bg-cream border-b border-gold-subtle overflow-hidden" data-testid="marquee">
      <Marquee speed={30} gradient gradientColor="#F4F6F8" gradientWidth={70} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-body font-bold text-navy text-sm uppercase tracking-[0.16em] px-7">{w}</span>
            <span className="w-1.5 h-1.5 rounded-full bg-barn" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
